// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___2d6daedd246515809fb","cls2":"SimplePaperPodcast-cls2__cc9ac3cf4b8ec83ccc4a SimplePaperPodcast-cls1___2d6daedd246515809fb"};